<template>
    <!-- 通知设置 -->
    <el-dialog title="通知设置"
      top="7vh"
      width="80%"
      :visible.sync="userNotifyConfigDialogVisible">

      <UserNotifyConfigTable ref="configTable_1"/>

      <div style="margin-bottom:20px;margin-left:10px;">
        <span>如果账号没有邮箱，需要</span>
        <a href="javascript:alert('开发中,请联系管理员修改');">去补充</a>
      </div>
      <div style="margin-bottom:20px;margin-left:10px;">
        <span>如果账号没有绑定企业微信，需要</span>
        <a href="/ticket-vue/bind-work-weixin" target="_blank">去绑定</a>
      </div>
    </el-dialog>
</template>

<script>
import EventBus from '@/assets/EventBus.js';

export default {
  name: "UserNotifyConfigDialog",

  data() {
    return {
      userNotifyConfigDialogVisible : false
    };
  },

  mounted() {
    EventBus.$on('showUserNotifyConfig', this.showUserNotifyConfig);
  },

  methods: {
    showUserNotifyConfig() {
      this.userNotifyConfigDialogVisible = true;

      // 加载数据
      if ( !!this.$refs.configTable_1 ) {
        this.$refs.configTable_1.showUserNotifyConfig();
      } else {
        setTimeout(this.showUserNotifyConfig, 1000); // 如果组件还没准备好 就稍后执行
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ticket/UserNotifyConfigDialog.vue